import { ConfigTypes } from 'src/AppState/ConfigState/types';

export const features: ConfigTypes = {
    /* A */
    anniversaryInfoShow: false,
    accountTradingCountryClub: false,
    accountTradingDragonCircle: false,
    accountTradingRewardZone: false,
    accountTradingTartanClub: false,
    affiliateIdPromoCode: false,
    activityTimeframe: false,

    /* B */
    betBuilderReferralSwitchShow: true,

    /* C */
    casinoProviders: {
        casino: ['evolution', 'leap', 'pragmatic', 'sg-digital', 'relax', 'blueprint'],
        'live-casino': ['evolution', 'ezugi', 'pragmatic'],
        virtuals: ['pragmatic', 'leap'],
    },
    closureCodes: true,
    cmsHiddenTabs: ['headlineCarousel', 'promoCode'],
    complianceRestrictionSummary: false,
    contactPreferences: {
        preferences: ['email', 'sms', 'phone'],
        options: ['betting', 'casino'],
        newMarketing: true,
    },
    currencies: ['GBP', 'EUR', 'XTS'],
    cpfProperties: false,
    casinoStoreEnabled: false,

    /* D */
    dashboardTab: true,
    decimalLength: 2,
    depositLimitType: 'rollingType',
    depositLimitCalculationTypeConfigurable: true,
    depositRestriction: true,
    deceased: false,

    /* E */
    externalId: false,

    /* F */
    configurationManagerUI: false,
    failedWithdrawalsFundsEnabled: true,
    footerContentDefault: {
        description_text:
            'Proper Bet is a trading name of Proper Bet Limited, a company incorporated in England and Wales with company number 16642166. Registered office: Equinox House, Clifton Park Avenue, York, North Yorkshire, England, YO30 5PA. Proper Bet Limited is licensed and regulated in Great Britain by the Gambling Commission under account number {{licenceNumber}}.',
        licence_number: '100990',
        licence_url: 'https://www.gamblingcommission.gov.uk/public-register/business/detail/100990',
        cookies_url: 'https://proper.bet/?account=static&static=cookie-policy',
        has_cookies: true,
    },
    footerLegalTextTab: true,
    fullNameProperties: false,

    /* H */
    hasNewMenu: true,
    hideDeleteImageButtonOnHomePageCarousel: false,
    hasXtremepush: false,

    /* G */
    gamprotect: false,
    gamstopNew: true,
    gamstopPpBlockedSuspendedActions: false,
    golfOnVirtuals: false,
    gtm: '',

    /* I */
    isAffordability: true,
    isPEP: true,
    identity: true,
    idMission: false,
    isBoostedPriceAvailable: true,
    indexNow: null,

    /* L */
    languages: [
        {
            value: 'en',
            label: 'English',
        },
    ],

    /* O */
    operatorFullName: 'Proper Bet',

    /* P */
    personalId: false,
    paymentSearchWalletAddress: false,
    pof: true,
    promotionHistoryEnabled: true,

    /* R */
    realityCheckLimitedType: true,
    reportDownloadOptions: ['Export to CSV'],
    redirectToNewBetTickerPage: false,
    redirectToNewCMSPage: false,
    reportsV2: false,
    redirectToNewTradingPage: false,
    showRingFencedFunds: true,

    /* M */
    markersOfHarm: true,
    mobilePrefixDisabled: false,
    dopplernegroPrefix: false,
    minDepositAmount: '5',
    minWithdrawAmount: '1',
    minManualAdjustmentAmount: '1',

    /* N */
    newPragmatic: true,
    newPofSrg: true,
    notificationSounds: {
        newChat: 'ding',
        newBetReferral: 'ding',
    },

    /* S */
    sourceOfFunds: true,
    srgEnabled: true,
    starEventsLabel: 'Proper Bet Events',
    showBonusEngine: true,
    showNewCustomerSettings: false,
    showRABInputs: true,
    showBonusCreator: false,
    staffCardDepositsEnabled: true,
    staffCardWithdrawalsEnabled: true,
    staffWithdrawalCardProvider: null,

    /* T */
    tableauDashboards: true,
    tagManagementTab: true,
    topEvents: false,

    /* U */
    useExtraPlacesForEvents: false,
    usePaymentFormForUniverse: {
        type: 'multi-deposit',
        apiKey: 'TODO',
        environment: 'LIVE',
        cardAccounts: {
            GBP: 'TODO',
            EUR: '', // TODO - add this value when ready: https://portals.paysafe.com/portal/developer/webhooks
        },
        openBanking: null,
    },
    userTitleOptional: false,

    /* V */

    /* W */
    withdrawalsTabsShow: true,
    withdrawalStandardLimit: '5000',
    workbookView: {
        BackofficeReports: 'BackOfficeReports-ProperBet/DB-Casino',
        BespokeReports: 'BespokeReports-ProperBet/DB-NewRewards',
        CasinoDashboard: 'CasinoDashboard-ProperBet/CasinoMainDashboard',
        ComplianceDashboard: 'ComplianceDashboard-ProperBet/ComplianceMainDashboard',
        MarketingDashboard: 'MarketingDashboard-ProperBet/MarketingMainDashboard',
        ProfitAndLossKPIs: 'ProfitandLossKPIs-ProperBet/DailyKPI',
        RacecourseDashboard: 'Racecourse-ProperBet/RacecourseMediaGroupDashboard',
        TransactionsDashboard: 'TransactionsDashboard-ProperBet/TransactionsMainDashboard',
        AccountBalances: 'AccountBalances-ProperBet/AccountBalances',
        RollingNetDeposits: 'RollingNetDeposits-ProperBet/RollingNetDeposits',
        BonusEngine: 'BonusEngine-ProperBet/CampaignLevel',
        SRGDashboard: 'SRGDashboard-ProperBet/DBAverageStakes',
        AuditsCustomerLists: 'AuditCustomerLists-ProperBet/Deposits',
    },
};
